import { BareButton } from '@calendly/ui/components/bare-button';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import AddToEmailSVG from './add_to_email.svg';
const addToEmailImgCss = "aqoetz0";
const AddToEmailImg = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  const src = AddToEmailSVG;
  const alt = '';
  return <Component ref={ref} {...restProps} src={src} alt={alt} className={classNames(addToEmailImgCss, props.className)} />;
});
const addTimesToEmailLogoIsPhoneCss = "a1omqs7r";
const addTimesToEmailLogoCss = "a1k1eyu7";
const AddTimesToEmailLogo = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(addTimesToEmailLogoCss, {
    [addTimesToEmailLogoIsPhoneCss]: isPhone
  }, props.className)}>
      <AddToEmailImg />
    </Component>;
});
const headerCss = "h1cos4pr";
const Header = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'h2';
  return <Component ref={ref} {...restProps} className={classNames(headerCss, props.className)} />;
});
const flexWrapperIsPhoneCss = "f1jyderd";
const flexWrapperCss = "fmoaqx1";
const FlexWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(flexWrapperCss, {
    [flexWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const titleIsPhoneCss = "t14r7dte";
const titleCss = "thoiez8";
const Title = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'h3';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(titleCss, {
    [titleIsPhoneCss]: isPhone
  }, props.className)} />;
});
const descriptionCss = "d10eokve";
const Description = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(descriptionCss, props.className)} />;
});
const buttonContainerIsPhoneCss = "b18cjj5o";
const buttonContainerCss = "bsaxs1a";
const ButtonContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(buttonContainerCss, {
    [buttonContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const previewToggleIsPhoneCss = "p1llcdxe";
const previewToggleCss = "pfptf09";
const PreviewToggle = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <BareButton ref={ref} {...props} className={classNames(previewToggleCss, {
    [previewToggleIsPhoneCss]: isPhone
  }, props.className)} />;
});
const previewWrapperIsPhoneCss = "pskq8ro";
const previewWrapperCss = "p10n4prv";
const PreviewWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(previewWrapperCss, {
    [previewWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const previewHeaderCss = "p1jlgotd";
const PreviewHeader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(previewHeaderCss, props.className)} />;
});
const previewTitleCss = "p1r83n2p";
const PreviewTitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(previewTitleCss, props.className)} />;
});
const previewBodyIsPhoneCss = "p1ds7vhv";
const previewBodyCss = "pnzlpg1";
const PreviewBody = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(previewBodyCss, {
    [previewBodyIsPhoneCss]: isPhone
  }, props.className)} />;
});
export { AddTimesToEmailLogo, Header, FlexWrapper, Title, Description, ButtonContainer, PreviewToggle, PreviewWrapper, PreviewHeader, PreviewTitle, PreviewBody };

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");